<template>
    <div class="famous-pedia-rwp-bottombar">
        <div class="web-inner-content dsp-flex">
            <div class="famous-pedia-rwp-share dsp-flex">
                <div class="famous-pedia-rwp-share-item" @click="clickShare">
                    <i class="iconfont icon-share2"></i>分享
                </div>
                <div class="famous-pedia-rwp-share-item" @click="clickCollect">
                    <i class="iconfont" v-bind:class="{'icon-star': !curPediaBaziCollect, 'icon-star-shi': curPediaBaziCollect}"></i>{{curPediaBaziCollect ? '取消收藏' : '收藏'}}
                </div>
                <div class="famous-pedia-rwp-share-item" @click="clickEdit">
                    <i class="iconfont icon-edit2"></i>纠错补充
                </div>
            </div>
            <div class="famous-pedia-rwp-typetext">
                <famous-comment-bottom-bar
                    class="famous-pedia-rwp-bottom-bar-box">
                </famous-comment-bottom-bar>
            </div>

            <!-- 分享弹框 -->
            <div class="layout-overlay layout-overlay-blank" v-if="showSharePop" @click="clickBlankOverlay"></div>
            <div v-if="showSharePop" class="famous-pedia-rwp-share-pop">
                <div class="famous-pedia-rwp-item" @click="clickCopy">
                    <i class="iconfont icon-link"></i>复制链接
                </div>
                <div class="famous-pedia-rwp-item" @click="clickQQShare">
                    <i class="iconfont icon-qq"></i>QQ空间
                </div>
                <div class="famous-pedia-rwp-item">
                    <i class="iconfont icon-wechat"></i>微信扫一扫
                </div>
                <div class="famous-pedia-rwp-code">
                    <qrcode id='qrImg' tag="img" :options="{size: 100, padding: 0}" :value="CONFIG.getWechatShareUrl(curPediaBaziInfo.id)" ></qrcode>
                </div>
                <span class="famous-pedia-rwp-triangle"></span> 
            </div>
        </div>
    </div>
</template>

<script>
import FamousCommentBottomBar from '../../layouts/famouscomment/FamousCommentBottomBar.vue'
import { CONST_FAMOUS_PEDIA_EDIT_TYPE } from '../../modules/data/base/consts';
import { CONFIG } from '../../modules/config';
import { UTILS } from '../../modules/utils';
import { FAMOUS_DOM } from '../../modules/dom';
export default {
    name: 'WebFamousPediaBottomBar',
    components: { FamousCommentBottomBar },
    computed: {
        userData() {
            return this.$store.state.userData;
        },
        curPediaBaziInfo() {
            return this.$store.state.famouspedia.curPediaBaziInfo;
        },
        curPediaBaziCollect() {
            return this.$store.state.famouspedia.curPediaBaziCollect;
        },
    },
    data() {
        return {
            CONFIG: CONFIG,
            showSharePop: false
        }
    },
    methods: {
        clickShare() {
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    me.showSharePop = true;
                }
            })
        },
        clickCollect() {
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    me.$store.dispatch('famouspedia/toggleCollectBaike', {
                        sucCCb: function() {
                            me.$toast('收藏成功');
                        },
                        sucUnCCb: function() {
                            me.$toast('取消收藏成功');
                        }
                    });
                }
            });
        },
        clickEdit() {
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    FAMOUS_DOM.bindFamousFormScrollEvent(false);
                    me.$store.state.famouspedia.curPediaEditType = CONST_FAMOUS_PEDIA_EDIT_TYPE.modify;
                    me.$store.state.weblogin.showWebFamousPediaPop = false;
                    me.$router.replace('/famouspediaeditweb/read')
                }
            });
        },
        clickBlankOverlay() {
            this.showSharePop = false;
        },
        clickCopy() {
            var me = this;
            UTILS.copyTextToClipboard(window.location.href, function() {
                me.$toast('复制链接成功');
                me.showSharePop = false;
            })
        },
        clickQQShare() {
            this.showSharePop = false;
            window.open(CONFIG.getQQShareUrl(this.curPediaBaziInfo));
        },
    }
}
</script>